
export enum DossierWizardType {
  DossierWizard = 'DossierWizard',
  PapSelectionWizard = 'PapSelectionWizard',
  TimetableWizard = 'TimetableWizard',
  CalendarWizard = 'CalendarWizard',
  InsertPapWizard = 'InsertPapWizard',
  TrainCompositionWizard = 'TrainCompositionWizard',
  AlternativeOfferPreview = 'AlternativeOfferPreview'
}
